import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PatientAiAnalysisService {
  private appointmentAIOutputsDeletedSource = new Subject<void>();
  appointmentAIOutputsDeleted$ =
    this.appointmentAIOutputsDeletedSource.asObservable();

  private appointmentAIOutputsCreatedSource = new Subject<void>();
  appointmentAIOutputsCreated$ =
    this.appointmentAIOutputsCreatedSource.asObservable();

  notifyAppointmentAIOutputsDeleted() {
    this.appointmentAIOutputsDeletedSource.next();
  }

  notifyAppointmentAIOutputsCreated() {
    this.appointmentAIOutputsCreatedSource.next();
  }
}
